export const translations = {
  es: {
    nav: {
      about: "Sobre nosotros",
      menu: "Carta",
      gallery: "Galería",
      reviews: "Reseñas",
      contact: "Contacto",
    },
    hero: {
      tagline: "Bergara · Gipuzkoa",
      title: "Telleixako Benta",
      subtitle:
        "Cocina tradicional vasca, casera y honesta. Pintxos en barra, menú del día y producto de temporada a la entrada de Bergara.",
      callBtn: "Llamar para reservar",
      mapBtn: "Cómo llegar",
    },
    about: {
      eyebrow: "Sobre nosotros",
      title: "Sabor de casa, alma vasca.",
      p1: "Restaurante de cocina tradicional vasca de comida casera. Un local moderno y acogedor con luminoso comedor para 50/60 comensales y dos terrazas.",
      p2: "Abrimos desde las 6:00 am con 20 a 30 pintxos en barra, desayunos y almuerzos, además de un excelente menú del día de lunes a viernes (comedor de 12:00 a 16:00).",
      p3: "Fácil aparcamiento para coches y camiones, junto a la gasolinera. La parada perfecta en tu camino.",
      stats: [
        { num: "06:00", label: "Abrimos cada mañana" },
        { num: "20+", label: "Pintxos en barra" },
        { num: "60", label: "Comensales en comedor" },
      ],
    },
    menu: {
      eyebrow: "Cocina y especialidades",
      title: "Recetas tradicionales, producto de temporada.",
      intro:
        "Frutas, legumbres, carnes de la zona y pescados frescos según mercado y temporada. Ofrecemos desayunos, almuerzos, pintxos, caldo, tortillas, raciones, bocadillos y uno de los mejores menús del día de la zona.",
      menuOfDay: {
        title: "Menú del día",
        schedule: "Lunes a Viernes · 12:00 — 16:00",
        line1: "5 primeros + 5 segundos + postres caseros",
        price: "17€",
        priceCoffee: "18€ con café",
        half: "Medio menú disponible · También para llevar",
      },
      highlights: "Destacan",
      dishes: [
        "Pasta y platos italianos",
        "Caldo tradicional, torreznos, tortillas",
        "Costilla basetxerri",
        "Secreto ibérico marinado",
        "Rape, salmón, bacalao, merluza",
        "Bocadillos y pintxos",
        "Cazuelitas",
        "Postres caseros",
      ],
    },
    gallery: {
      eyebrow: "Galería",
      title: "Lo que se cocina en casa.",
      visitTitle: "Visita el local",
      visitSubtitle: "Terraza y comedor a la entrada de Bergara, junto a la gasolinera.",
      items: [
        "Pintxos de champiñones con jamón",
        "Pintxo de croqueta crujiente con jamón",
        "Ensalada de queso de cabra y nueces",
        "Raciones para compartir",
        "Arroz del menú del día",
        "Gildas",
        "Caña fría en la barra",
        "Terraza de noche",
        "Cartel del local",
      ],
    },
    reviews: {
      eyebrow: "Reseñas",
      title: "Lo que dicen nuestros clientes.",
      items: [
        {
          name: "Mikel",
          text: "Buena recomendación, gracias. Comida, calidad-precio y servicio inmejorables.",
        },
        {
          name: "Andoni",
          text: "Comimos unos pintxos y después tuvimos que volver a probar el menú. Volveremos la próxima vez que estemos por la zona.",
        },
        {
          name: "Nando",
          text: "Menú muy completo, volveremos.",
        },
        {
          name: "Felisa",
          text: "Parece nuevo. Da gusto comer aquí: limpio, amable y con muy buen producto.",
        },
      ],
    },
    contact: {
      eyebrow: "Contacto y ubicación",
      title: "Te esperamos en Bergara.",
      address: "Calle Telleria, 16, Bajo · 20570 Bergara, Gipuzkoa",
      phoneLabel: "Teléfono",
      phone: "+34 943 29 17 30",
      scheduleTitle: "Horario",
      scheduleWeekdays: "Lunes a Viernes",
      scheduleWeekdaysHours: "06:00 — 21:00",
      scheduleWeekend: "Sábado y Domingo",
      scheduleClosed: "Cerrado",
      directionsBtn: "Abrir en Google Maps",
    },
    footer: {
      rights: "Todos los derechos reservados.",
      tagline: "Cocina vasca casera desde Bergara.",
      contactTitle: "Contacta con nosotros",
    },
    lang: { label: "Idioma" },
  },
  eu: {
    nav: {
      about: "Guri buruz",
      menu: "Karta",
      gallery: "Galeria",
      reviews: "Iritziak",
      contact: "Kontaktua",
    },
    hero: {
      tagline: "Bergara · Gipuzkoa",
      title: "Telleixako Benta",
      subtitle:
        "Euskal sukaldaritza tradizionala, etxeko ukitua. Pintxoak barran, eguneko menua eta sasoiko produktua, Bergararen sarreran.",
      callBtn: "Deitu erreserbatzeko",
      mapBtn: "Nola iritsi",
    },
    about: {
      eyebrow: "Guri buruz",
      title: "Etxeko zaporea, euskal arima.",
      p1: "Etxeko janariko euskal sukaldaritza tradizionalaren jatetxea. Lokal moderno eta atsegina, 50/60 lagunentzako jangela argitsuarekin eta bi terrazarekin.",
      p2: "Goizeko 6:00etatik irekita, 20 eta 30 pintxoren artean barran, gosariak eta hamaiketakoak, eta astelehenetik ostiralera eguneko menu bikaina (jangela 12:00etatik 16:00etara).",
      p3: "Aparkatzeko erraztasuna autoentzat eta kamioientzat, gasolindegiaren ondoan. Zure bidean geldialdi ezin hobea.",
      stats: [
        { num: "06:00", label: "Goizero zabaltzen dugu" },
        { num: "20+", label: "Pintxo barran" },
        { num: "60", label: "Mahaikide jangelan" },
      ],
    },
    menu: {
      eyebrow: "Sukaldaritza eta espezialitateak",
      title: "Errezeta tradizionalak, sasoiko produktua.",
      intro:
        "Inguruko fruta, lekale eta haragiak, eta merkatuaren araberako arrain freskoak. Gosariak, hamaiketakoak, pintxoak, salda, tortillak, errazioak, ogitartekoak eta inguruko eguneko menu onenetakoa eskaintzen ditugu.",
      menuOfDay: {
        title: "Eguneko menua",
        schedule: "Astelehenetik ostiralera · 12:00 — 16:00",
        line1: "5 lehenengo + 5 bigarren + etxeko postreak",
        price: "17€",
        priceCoffee: "18€ kafearekin",
        half: "Menu erdia eskuragarri · Eramateko ere bai",
      },
      highlights: "Nabarmentzen",
      dishes: [
        "Pasta eta plater italiarrak",
        "Salda tradizionala, txerri-azala, tortillak",
        "Basetxerri saiheskia",
        "Iberiar sekretua marinatua",
        "Itsas zapoa, izokina, bakailaoa, legatza",
        "Ogitartekoak eta pintxoak",
        "Kazolatxoak",
        "Etxeko postreak",
      ],
    },
    gallery: {
      eyebrow: "Galeria",
      title: "Etxean prestatzen duguna.",
      visitTitle: "Etorri lokalera",
      visitSubtitle: "Terraza eta jangela, Bergararen sarreran eta gasolindegiaren ondoan.",
      items: [
        "Onddoen pintxoa urdaiazpikoarekin",
        "Kroketa krispyaren pintxoa urdaiazpikoarekin",
        "Ahuntz-gazta eta intxaurren entsalada",
        "Errazioak partekatzeko",
        "Eguneko menuko arroza",
        "Gildak",
        "Garagardo freskoa barran",
        "Terraza gauez",
        "Tabernako iragarki-panela",
      ],
    },
    reviews: {
      eyebrow: "Iritziak",
      title: "Gure bezeroek diotena.",
      items: [
        {
          name: "Mikel",
          text: "Gomendio bikaina, eskerrik asko. Janaria, kalitate-prezioa eta zerbitzua aparta.",
        },
        {
          name: "Andoni",
          text: "Pintxo batzuk jan genituen eta gero menua probatzera itzuli behar izan genuen. Berriz etorriko gara inguruan gaudenean.",
        },
        {
          name: "Nando",
          text: "Menu oso osatua, itzuliko gara.",
        },
        {
          name: "Felisa",
          text: "Berria dirudi. Hemen jatea atsegina da: garbi, atsegin eta produktu bikainarekin.",
        },
      ],
    },
    contact: {
      eyebrow: "Kontaktua eta kokapena",
      title: "Bergaran zain zaitugu.",
      address: "Telleria kalea, 16, Behea · 20570 Bergara, Gipuzkoa",
      phoneLabel: "Telefonoa",
      phone: "+34 943 29 17 30",
      scheduleTitle: "Ordutegia",
      scheduleWeekdays: "Astelehenetik ostiralera",
      scheduleWeekdaysHours: "06:00 — 21:00",
      scheduleWeekend: "Larunbata eta igandea",
      scheduleClosed: "Itxita",
      directionsBtn: "Ireki Google Maps-en",
    },
    footer: {
      rights: "Eskubide guztiak erreserbatuta.",
      tagline: "Etxeko euskal sukaldaritza Bergaratik.",
      contactTitle: "Jarri gurekin harremanetan",
    },
    lang: { label: "Hizkuntza" },
  },
};
